import React, { useState, useEffect } from "react";
//outsource
import { Row, Col, Table, Button, Space, Modal, message } from "antd";
import {
  EditOutlined,
  DeleteOutlined,
  ExclamationCircleFilled,
} from "@ant-design/icons";

//components
import { useDispatch, useSelector } from "react-redux";
import {
  selectDetailGroup,
  setOpenGroupDetail,
  setOpenDetailService,
  selectDetailService,
} from "../../../store/var/var.action";
import { searchSelector } from "../../../store/var/var.selector";
import { allSelector } from "../../../store/service/service.selector";
import { deleteServiceById } from "../../../store/service/service.action";

const { confirm } = Modal;

const ListItem = ({ data }) => {
  // -------------------------- VAR --------------------------
  const name = data?.name;
  const labelName = name?.toUpperCase();
  const groupId = data?.id || null;

  // -------------------------- STATE --------------------------
  const [dataTable, setDataTable] = useState([]);
  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();
  const services = useSelector(allSelector);
  const search = useSelector(searchSelector);

  // -------------------------- FUNCTION -----------------------
  const handleUpdate = () => {
    if (data) {
      dispatch(
        selectDetailGroup({ data }, () => {
          dispatch(setOpenGroupDetail({ data: true }));
        })
      );
    }
  };

  const handleEdit = (record) => {
    if (record) {
      dispatch(
        selectDetailService({ data: record }, () => {
          dispatch(setOpenDetailService({ data: true }));
        })
      );
    }
  };

  const showDeleteConfirm = (record) => {
    const nameService = record?.name;
    const id = record?.id;
    confirm({
      title: `Are you sure delete "${nameService}"?`,
      icon: <ExclamationCircleFilled />,
      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      onOk() {
        handleDelete(id);
      },
      onCancel() {
        console.log("Cancel");
      },
    });
  };

  const handleDelete = (id) => {
    if (id) {
      dispatch(
        deleteServiceById({ id }, (res) => {
          if (res.status === 200) {
            message.success("Deleted Successfully!");
          } else {
            message.error(res.data);
          }
        })
      );
    }
  };

  // -------------------------- EFFECT --------------------------
  useEffect(() => {
    if (services && groupId) {
      let target = services?.filter((item) => item?.group === groupId);

      if (search !== "") {
        target = target?.filter((item) => {
          const searchLower = search?.toLowerCase();
          const nameLower = item?.name?.toLowerCase();
          const valids = nameLower?.includes(searchLower);

          return valids;
        });
      }

      setDataTable(target);
    }
  }, [services, groupId, search]);
  // -------------------------- RENDER --------------------------
  const renderTitle = () => {
    return (
      <Row>
        <Col style={{ marginBottom: 20 }} flex="auto">
          <strong>{labelName}</strong>
          <span style={{ marginLeft: 10 }}>
            <Button
              type="link"
              icon={<EditOutlined />}
              onClick={handleUpdate}
            />
          </span>
        </Col>
      </Row>
    );
  };

  const columns = [
    {
      title: "#",
      dataIndex: "#",
      key: "#",
      render: (value, _record, index) => <>{index + 1}</>,
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Regular Price ($)",
      dataIndex: "regularPrice",
      key: "regularPrice",
      width: 100,
    },
    {
      title: "Special Price ($)",
      dataIndex: "price",
      key: "price",
      width: 100,
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
    },
    {
      title: "@",
      dataIndex: "@",
      key: "@",
      width: 100,
      render: (value, _record) => getAction(_record),
    },
  ];

  const getAction = (_record) => {
    return (
      <Space>
        <Button
          className="edit-btn"
          icon={<EditOutlined />}
          onClick={() => handleEdit(_record)}
        />
        <Button
          className="delete-btn"
          icon={<DeleteOutlined />}
          onClick={() => showDeleteConfirm(_record)}
        />
      </Space>
    );
  };

  const renderServicesTable = () => {
    return <Table bordered columns={columns} dataSource={dataTable} />;
  };

  // -------------------------- MAIN --------------------------
  if (dataTable?.length === 0) {
    return null;
  }

  return (
    <Row style={{ width: "100%" }}>
      <Col xl={24} lg={24} md={24} xs={24}>
        {renderTitle()}
      </Col>
      <Col xl={24} lg={24} md={24} xs={24}>
        {renderServicesTable()}
      </Col>
    </Row>
  );
};

export default ListItem;
